import { render, staticRenderFns } from "./vExpansionPanel.vue?vue&type=template&id=f08f4330&scoped=true"
import script from "./vExpansionPanel.vue?vue&type=script&lang=js"
export * from "./vExpansionPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08f4330",
  null
  
)

export default component.exports